// extracted by mini-css-extract-plugin
export var active = "_71-a";
export var activeIndicator = "_71-9";
export var disabled = "_71-b";
export var fullWidth = "_71-2";
export var lg = "_71-7";
export var md = "_71-6";
export var redoButtonTabGroup = "_71-0";
export var sm = "_71-5";
export var tabButton = "_71-4";
export var tabButtonsContainer = "_71-1";
export var themeDestructive = "_71-d";
export var themeNormal = "_71-c";
export var themeSuccess = "_71-e";
export var xl = "_71-8";
export var xs = "_71-3";